import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { IRootState } from '../../../../../../typings';
import { ICommentary } from '../../../../../commentaries/typings';
import { IMatchEventSubstitute } from '../../../../../matchEvents/typings';
import { getLiveMembership, getLiveTeam } from '../../../selector';

interface IOwnProps {
  commentary: ICommentary;
}

const mapDispatchToProps = {};
const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  const matchEvent = ownProps.commentary.matchEvent as IMatchEventSubstitute;
  const { matchTeamPosition, matchTeamPlayerId, playerOffId } = matchEvent;

  return {
    team: getLiveTeam(state, matchTeamPosition),
    playerIn: getLiveMembership(state, matchTeamPlayerId),
    playerOff: getLiveMembership(state, playerOffId),
  };
};

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  IOwnProps &
  InjectedIntlProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  injectIntl
);
